import { type BuildPlatform } from '../../model'
import linuxLogo from '../../assets/platforms/linux.png'
import questLogo from '../../assets/platforms/quest.png'
import windowsLogo from '../../assets/platforms/windows.png'

export const platformLogo: Record<BuildPlatform, string> = {
  windows: windowsLogo,
  quest: questLogo,
  linux: linuxLogo
}
